import { baseApi } from "../api";
import type {
	FriendShopFriendsResponse,
	FriendShopOffer,
	FriendShopResponse
} from "interfaces/friend-shop";

export type { FriendShopFriendsResponse, FriendShopOffer, FriendShopResponse };

export const friendShopAPI = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getGiftsFriendShop: builder.query<FriendShopResponse, void>({
			query: () => "/rest/friend/gift/shop",
			transformResponse: (
				response: FriendShopResponse
			): FriendShopResponse => ({
				...response,
				shopOffers: [...(response?.shopOffers ?? [])].sort(
					(a, b) => a.priority - b.priority
				)
			}),
			providesTags: () => [{ type: "friendShopGiftsTag" }]
		}),
		getFriendsFriendShop: builder.query<FriendShopFriendsResponse, void>({
			query: () => "/rest/user/linked?type=friend",
			providesTags: () => [{ type: "friendShopFriendsTag" }]
		})
	})
});

export const { useGetGiftsFriendShopQuery, useGetFriendsFriendShopQuery } =
	friendShopAPI;
